<aslib-title Text="Controle de Grupos" SubText=" " Icon="fa fas fa-tasks"></aslib-title>

<!-- <aslib-modal #modal></aslib-modal> -->

<div class="form-row">
  <div class="form-group col-sm-5">
    <button type="button" class="btn btn-primary" (click)="openModalGrupos(modalGrupo)">Incluir Grupo</button>
    <ng-template #modalGrupo>
      <gpa-modal-grupo 
        [projetosGruposAssociados]="lista">
      </gpa-modal-grupo>
    </ng-template>
  </div>
</div>


<aslib-grid #grid id="grid" name="grid" headerTitle="Grupos Associados" [(dataset)]="lista" indexColumnVisible="true" limit="10">
  <aslib-grid-column [property]="'id'" [visible]="false"  header="Sequencial" class="text-right" [width]="10"  [sortable]="true" [resizable]="true"></aslib-grid-column>
  <aslib-grid-column [property]="'codProjetoIntegradoPagamentoAutomatico'" header="Projeto" class="text-left" [width]="10" [sortable]="true" [resizable]="true"></aslib-grid-column>
  <aslib-grid-column [property]="'codGrupo'" header="Grupo" class="text-left" [width]="15" [sortable]="true"   [resizable]="true"></aslib-grid-column>
  <aslib-grid-column [property]="'active'" [header]="'Ações'" [width]="2" [sortable]="false" [resizable]="false" class="text-center">
    <ng-template #AslibGridHeader let-item="item"><span>Ações</span></ng-template>
    <ng-template #AslibGridCell let-item="item">
    <button type="button" class="btn btn-sm btn-danger" title="Excluir Grupo" ascas-data="Excluir Grupo" (click)="excluirGrupo(modal, item)">
      <aslib-icon type="1" icon="fa fa-fw fa-trash"></aslib-icon>
    </button>
    </ng-template>
  </aslib-grid-column>
</aslib-grid>
<br>



// WEBPACK FOOTER //
// ./src/app/controle-dados/grupo/grupo.component.html